import {typedQuery} from "../../typing.ts";
import api from "../../../api";

export const notificationPreferences = typedQuery(["notificationPreferences"], async () => {
  return await api.notificationPreferences.get_();
});
